export default "__VITE_ASSET__59324604__"